import axios from "axios";
import { Platform } from "react-native";
import Config from "react-native-config";
import { APIService } from "../../utilities/Constants";

export const getBaseUrl = (service: number): string => {
  const urls = {
    [APIService.harmony]:
      Platform.OS === "web"
        ? process.env.REACT_APP_BASE_API_URL
        : Config.REACT_APP_BASE_API_URL,
    [APIService.exzeo]: `https://${
      Platform.OS === "web"
        ? process.env.REACT_APP_EXZEO_ID_DOMAIN
        : Config.REACT_APP_EXZEO_ID_DOMAIN
    }`,
    [APIService.notificationService]:
      Platform.OS === "web"
        ? process.env.REACT_APP_NOTIFICATION_API_URL
        : Config.REACT_APP_NOTIFICATION_API_URL,
    [APIService.other]: "https://iid.googleapis.com/iid",
  };
  return urls[service] || "";
};

export const createAxiosInstance = (service: number) => {
  return axios.create({
    baseURL: getBaseUrl(service),
    timeout: 45000,
  });
};

// file name to be changed to index.ts
